import { render, staticRenderFns } from "./ExternalUser.vue?vue&type=template&id=66061520&scoped=true&"
import script from "./ExternalUser.vue?vue&type=script&lang=ts&"
export * from "./ExternalUser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66061520",
  null
  
)

export default component.exports